module.exports = __webpack_public_path__ + "static/media/inventoryManagementsystem.88d654a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/Mtechold/inventoryManagementsystem.png
// module id = 334
// module chunks = 0